import * as Types from './navActionTypes.js'

const initialState = {
    smart: "PRODUCTION",
    showActiveLines: false,
    currentURL: "/",
    user: null
};

export default function nav(state = initialState, action) {
    switch (action.type) {
        case Types.SET_SMART:
            if (state.smart !== action.smart) {
                return Object.assign({}, state, { smart: action.smart });
            }
            return state;
        case Types.SET_SHOWACTIVELINES:
            if (state.showActiveLines !== action.showActiveLines) {
                return Object.assign({}, state, { showActiveLines: action.showActiveLines });
            }
            return state;
        case Types.SET_CURRENTURL:
            if (state.currentURL !== action.currentURL) {
                return Object.assign({}, state, { currentURL: action.currentURL });
            }
            return state;
        case Types.SET_USER:
            if (state.user !== action.user) {
                return Object.assign({}, state, { user: action.user });
            }
            return state;
        default:
            return state;
    }
}